import { KOCHI_LOCATIONS } from '../constants/locations.js';
import { substituteMarketingBrandingInText } from './marketingSiteContact.js';
import type { HubPageSeoEntry } from './publicMarketingConfig.js';

/** Example service/location paths for super-admin landing SEO overrides. */
export const LANDING_PAGE_SEO_EXAMPLES: Array<{ path: string; label: string }> = [
  { path: '/deep-cleaning-kochi', label: 'Deep cleaning service' },
  { path: '/home-cleaning-kochi', label: 'Home cleaning service' },
  { path: '/bed-bug-treatment-kochi', label: 'Bed bug treatment landing' },
  { path: '/guides/toilet-acid-wash-kochi', label: 'Guide — Toilet acid wash' },
  { path: '/guides/pest-control-home-kochi', label: 'Guide — Pest control home' },
  { path: '/housekeeping-services-kochi', label: 'Housekeeping services Kochi' },
  { path: '/same-day-cleaning-kochi', label: 'Same-day cleaning' },
  ...KOCHI_LOCATIONS.map((location) => ({
    path: location.href,
    label: `Location — ${location.name}`,
  })),
];

export function normalizeMarketingPath(path: string): string {
  const trimmed = path.trim();
  if (!trimmed) return '';
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

export function hasLandingPageSeoOverride(
  path: string,
  landingPageSeo?: Partial<Record<string, HubPageSeoEntry>>,
): boolean {
  const canonical = normalizeMarketingPath(path);
  const entry = landingPageSeo?.[canonical];
  return Boolean(entry?.title?.trim() || entry?.description?.trim());
}

export function resolveLandingPageSeoCopy(
  path: string,
  defaults: { title: string; description: string },
  branding: { phone?: string; email?: string; companyName?: string },
  landingPageSeo?: Partial<Record<string, HubPageSeoEntry>>,
): { title: string; description: string } {
  const canonical = normalizeMarketingPath(path);
  const override = landingPageSeo?.[canonical];
  const titleSource = override?.title?.trim() || defaults.title;
  const descriptionSource = override?.description?.trim() || defaults.description;
  return {
    title: substituteMarketingBrandingInText(titleSource, branding),
    description: substituteMarketingBrandingInText(descriptionSource, branding),
  };
}
